import { useEffect, useState } from "react";

const cache = new Map();
const pending = new Map();

function load(client, url) {
  if (cache.has(url)) return Promise.resolve(cache.get(url));
  if (!pending.has(url)) {
    pending.set(url, client.get(url, { responseType: "blob" })
      .then((r) => { const u = URL.createObjectURL(r.data); cache.set(url, u); return u; })
      .finally(() => pending.delete(url)));
  }
  return pending.get(url);
}

export function useBlobImage(client, url) {
  const [src, setSrc] = useState(url ? cache.get(url) || null : null);
  useEffect(() => {
    if (!url) return setSrc(null);
    let alive = true;
    load(client, url).then((u) => alive && setSrc(u)).catch(() => alive && setSrc(null));
    return () => { alive = false; };
  }, [client, url]);
  return src;
}
